import React from 'react'
import { Grid, IconButton } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'
import SearchIcon from '@material-ui/icons/Search'

import NewsSearchBar from '../../../features/news/components/NewsSearchBar/NewsSearchBar'
import { updateSearchBarContents } from '../../../features/news/newsSlice'

import {
  LogOutButton,
  MyAlertsAndNotifications,
  VisitorModeLabel,
} from './DashboardLocalButtons'
import ManageNews from '../../../features/news/components/ManageNews/ManageNews'

export default function NewsLocalButtons({
  classes,
  history,
  isMobile,
  dispatch,
  search,
  userProfile,
  activeAlerts,
  activeNotificationList,
  dialogOpen,
}) {
  const isGuest =
    localStorage.getItem('user') === '"visitor"' ||
    localStorage.getItem('user') === ''
  return (
    <>
      <Grid item sm={4} md={4}>
        <Grid container justifyContent="flex-end" alignItems="center">
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            style={{ flexWrap: 'nowrap' }}
          >
            {!isMobile ? (
              <Grid item>
                <VisitorModeLabel classes={classes} />
              </Grid>
            ) : null}
            <Grid item>
              <ManageNews />
            </Grid>
            {!isMobile && (
              <Grid
                item
                className={classes.searchBarContainer}
                md={5}
                sm={7}
                xs={9}
              >
                <NewsSearchBar />
              </Grid>
            )}
            <MyAlertsAndNotifications
              dispatch={dispatch}
              isMobile={isMobile}
              isGuest={isGuest}
              classes={classes}
              activeAlerts={activeAlerts}
              activeNotificationList={activeNotificationList?.length}
              dialogOpen={dialogOpen}
            />
            {isMobile && (
              <>
                <Grid item>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="Rutgers Search"
                    onClick={() =>
                      dispatch(
                        updateSearchBarContents({
                          ...search,
                          enableSearch: !search.enableSearch,
                          searchQuery: '',
                          articleList: [],
                        }),
                      )
                    }
                  >
                    <SearchIcon className={classes.appBarIcon} />
                  </IconButton>
                </Grid>
                <Grid item>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="Settings Menu"
                    onClick={() => history.push('/settings')}
                  >
                    <SettingsIcon className={classes.appBarIcon} />
                  </IconButton>
                </Grid>
              </>
            )}
            <LogOutButton
              isMobile={isMobile}
              dispatch={dispatch}
              userProfile={userProfile}
              classes={classes}
              history={history}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
